"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FormDatePicker',
  props: {
    val: {
      type: [String, Number, Date],
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 格式化输入
    valueformat: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      inputVal: this.val
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = this.placeholder || this.$t('common.selectDatetime');
      return this.isDisabled ? '' : txt;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.inputVal = newVal;
      }
    }
  },
  methods: {
    onChange: function onChange(val) {
      if (this.isDisabled) {
        return false;
      }
      this.$emit('update:val', val);
    }
  }
};